import { render, staticRenderFns } from "./BecomeTco.vue?vue&type=template&id=6b739eda"
import script from "./BecomeTco.vue?vue&type=script&lang=js"
export * from "./BecomeTco.vue?vue&type=script&lang=js"
import style0 from "./BecomeTco.vue?vue&type=style&index=0&id=6b739eda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports